import './styles/App.css';
import LightsOutContainer from './LightsOutContainer';

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <LightsOutContainer />
      </header>
    </div>
  );
}

export default App;
